/**
 * Fetches Stripe Checkout Session details for client-side analytics (e.g. PostHog revenue tracking).
 * Used on thank-you page when session_id is present in the URL.
 */

export interface StripeSessionDetails {
  amount_total: number;
  currency: string;
  payment_status?: string;
  metadata?: Record<string, string>;
  subscription?: string;
  payment_method_types?: string[];
}

export async function fetchStripeSessionDetails(
  sessionId: string,
): Promise<StripeSessionDetails | null> {
  if (!sessionId?.trim()) return null;
  try {
    const base =
      typeof window !== "undefined"
        ? window.location.origin
        : "";
    const url = `${base}/api/stripe-session?session_id=${encodeURIComponent(sessionId.trim())}`;
    const response = await fetch(url);
    if (!response.ok) return null;
    const data = (await response.json()) as StripeSessionDetails & { error?: string };
    if (data?.error) return null;
    return data as StripeSessionDetails;
  } catch (error) {
    console.error("[stripeSessionHelper] Failed to fetch session details:", error);
    return null;
  }
}
